import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useStorage } from '~Components/Storage';

import { useI18n, useSelector } from '~Hooks';
import Station from '~Scenes/Settings-v2/Scenes/Stations';
import { StyledH2, StyledH4 } from '~ComponentsImproved/Typography/Heading/styles';
import Modal, { insideWrapperStyles } from '~ComponentsImproved/Modal';

const Content = styled.div`
  box-shadow: ${insideWrapperStyles.boxShadow};
  border-radius: ${insideWrapperStyles.borderRadius};
  background-color: ${insideWrapperStyles.backgroundColor};
  width: 550px;
  min-height: 550px;
  max-height: 90%;
  overflow-y: auto;
  padding: 24px 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StationWrapper = styled.div`
  margin: 0px 80px;
`;

const Title = styled(StyledH2)`
  text-align: center;
  color: var(--colorWhite);
  margin-bottom: 0px;
`;

export const Subtitle = styled(StyledH4)`
  font-size: 16px;
  opacity: 0.7;
  text-align: center;
  color: var(--colorWhite);
  margin: 20px 80px;
`;

const SelectStation: FC = () => {
  const { i18n } = useI18n();
  const stations = useSelector((state) => state.stations);
  const [{ selectedKDSStation }] = useStorage();

  /* Don't show if company has no stations */
  if (!stations || !stations.length) {
    return null;
  }

  /* Don't show if station is NONE */
  if (selectedKDSStation === 'NONE') {
    return null;
  }

  /* Show if stationId is already set or if it can't be found among company stations */
  const showSelectStation =
    !selectedKDSStation || !stations.find((station) => station.id === selectedKDSStation);
  if (!showSelectStation) {
    return null;
  }

  return (
    <Modal isShowing backdropClose={false}>
      <Content>
        <Title>{i18n('KDS.AssignStation')}</Title>
        <Subtitle>{i18n('KDS.AssignStation.Subtitle')}</Subtitle>
        <StationWrapper>
          <Station isInKDSModal />
        </StationWrapper>
      </Content>
    </Modal>
  );
};

export default SelectStation;
